import { KModal, KText } from '@/ui-library/components';
import { Avatar, Box } from '@chakra-ui/react';

export const OverrideScorecardModal = ({
  draftScActions,
  onCTAClick,
  scorecard,
}) => {
  return (
    <KModal
      isOpen={draftScActions?.isOpen}
      onClose={draftScActions?.onClose}
      title="Replace scorecard draft"
      ctaLabel="Confirm"
      ctaAction={() => {
        onCTAClick?.();
        draftScActions?.onClose();
      }}
      modalHeaderProps={{ py: '16px', pr: '40px' }}
      modalBodyProps={{ pb: '16px' }}
    >
      <Box>
        <Avatar
          src={scorecard?.submitted_by?.avatar}
          name={scorecard?.submitted_by?.name}
          width="16px"
          height="16px"
          className="avatar-xs"
          mr="6px"
          mt="5px"
          borderRadius="2px"
        />
        <KText as="span" fontSize="14px" fontWeight="550" color="secondary-900">
          {scorecard?.submitted_by?.name || 'Someone'}
        </KText>
        <KText as="span">
          {` has already saved a draft of this scorecard. Do you want to replace it?`}
        </KText>
      </Box>
    </KModal>
  );
};
